import { Injectable } from '@angular/core';
import { Store } from '../store';
import * as Cookies from 'cookies-js';
import { ToolsService } from './tools.service';

@Injectable({
    providedIn: 'root'
})
export class CookieService {
    private static readonly LOGIN_STATUS = 'yssLoginStatus';
    private static readonly USER_COOKIE = 'yssAdminUser';
    private static readonly BASKET_COOKIE = 'ysBasket';
    private static readonly BASKETID_COOKIE = 'ysBasketId';
    private cookieExpiration = 86400 * 7;
    private cookieExtendedExpiration = 86400 * 7;

    constructor(
        private store: Store,
        private toolsService: ToolsService,
    ) {
    }

    setUser(data) {
        let decodedCookie = {
            token: '',
            user: undefined,
        };
        const cookieData = Cookies.get(CookieService.USER_COOKIE);
        if (cookieData) {
            decodedCookie = JSON.parse(cookieData);
        }
        decodedCookie.user = data;
        const expires = this.cookieExtendedExpiration;
        Cookies.set(
            CookieService.USER_COOKIE, JSON.stringify(decodedCookie),
            { expires }
        );
    }

    remove() {
        Cookies.expire(CookieService.LOGIN_STATUS);
        Cookies.expire(CookieService.USER_COOKIE);

        this.store.set('user', undefined);
        this.store.set('token', '');
    }

    setLoggedIn(status = true) {
        let expires = this.cookieExpiration;

        Cookies.set(
            CookieService.LOGIN_STATUS, JSON.stringify(status),
            { expires }
        );
    }

    check() {
            let cookieData:boolean;
            try {
                cookieData=  JSON.parse(Cookies.get(CookieService.LOGIN_STATUS));
            } catch {
                cookieData = undefined;
            }
        if (cookieData) {
            this.store.set('loggedIn', true);
            return true;
        }

        this.store.set('user', undefined);
        this.store.set('token', '');
        this.store.set('loggedIn', false);
        return false;
    }

    checkUser() {
        if (Cookies.get(CookieService.USER_COOKIE)) {
            const cookieData = JSON.parse(Cookies.get(CookieService.USER_COOKIE));
            if (cookieData?.user?.id ) {
                this.store.set('user', cookieData.user);
                this.store.set('accountType', cookieData.user.accountType);
                return true;
            }
            return false;
        } else {
            this.store.set('user', undefined);
            this.store.set('loggedIn', false);
            this.store.set('accountType', '');
            return false;
        }
    }

    isAuthenticated() {
        const promise = new Promise(
            (resolve, reject) => {
                resolve(this.check());
            }
        );
        return promise;
    }

    hasUserData() {
        const promise = new Promise(
            (resolve, reject) => {
                resolve(this.checkUser());
            }
        );
        return promise;
    }

    setBasket(data) {
        const expires = this.cookieExtendedExpiration;
        Cookies.set(
            CookieService.BASKET_COOKIE, JSON.stringify(data),
            { expires }
        );
    }

    getBasket() {
        if (Cookies.get(CookieService.BASKET_COOKIE)) {
            const cookieData = JSON.parse(Cookies.get(CookieService.BASKET_COOKIE));
            this.store.set('basket', cookieData);
            return true;
        }
    }


    getBasketId() {
        let basketId = '';

        if (Cookies.get(CookieService.BASKETID_COOKIE)) {
            basketId = Cookies.get(CookieService.BASKETID_COOKIE);
            this.store.set('basketId', basketId);
        } else {
            basketId = this.toolsService.newUUID();
            const expires = this.cookieExtendedExpiration;
            Cookies.set(CookieService.BASKETID_COOKIE, basketId, { expires });
            this.store.set('basketId', basketId);
        }
        return basketId;
    }

    setBasketId(id) {
        const expires = this.cookieExtendedExpiration;
        Cookies.set(CookieService.BASKETID_COOKIE, id, { expires });
        this.store.set('basketId', id);
        return id;
    }


}
